/**
 * @generated SignedSource<<1786786af5fbe9ee3a2042731a1d34f9>>
 * @relayHash f1f5bc833b3adcfaa8f23a0262a11c35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a3dfcdba660c43ea3c005773a8867b277288a1f1828accb84953d86fd5503884

import type { ConcreteRequest } from 'relay-runtime';
export type HomeWidgetState = "COLLAPSED" | "EXPANDED" | "%future added value";
export type useHomeWidgetStateQuery$variables = Record<PropertyKey, never>;
export type useHomeWidgetStateQuery$data = {
  readonly userPreferences: {
    readonly __typename: "UserPreferences";
    readonly homeWidgets: ReadonlyArray<{
      readonly __typename: "HomeWidget";
      readonly id: string;
      readonly state: HomeWidgetState;
    }>;
  } | null;
};
export type useHomeWidgetStateQuery = {
  response: useHomeWidgetStateQuery$data;
  variables: useHomeWidgetStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v1 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "concreteType": "HomeWidget",
        "kind": "LinkedField",
        "name": "homeWidgets",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "state"
          },
          (v0/*: any*/)
        ]
      },
      (v0/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useHomeWidgetStateQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useHomeWidgetStateQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f1f5bc833b3adcfaa8f23a0262a11c35",
    "id": "a3dfcdba660c43ea3c005773a8867b277288a1f1828accb84953d86fd5503884",
    "metadata": {},
    "name": "useHomeWidgetStateQuery",
    "operationKind": "query",
    "text": "query useHomeWidgetStateQuery{userPreferences{homeWidgets{id,state,__typename},__typename}}"
  }
};
})();

(node as any).hash = "2b3d6cba775f89e74fb24fec1d37c65d";

export default node;
